// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgKeyboard24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M11 3.25C11.9665 3.25 12.75 4.0335 12.75 5V7C12.75 7.08817 12.7348 7.17279 12.7068 7.25137L19 7.25C20.5188 7.25 21.75 8.48122 21.75 10V18C21.75 19.5188 20.5188 20.75 19 20.75H5C3.48122 20.75 2.25 19.5188 2.25 18V10C2.25 8.48122 3.48122 7.25 5 7.25L11.2932 7.25137C11.2652 7.17279 11.25 7.08817 11.25 7V5C11.25 4.86193 11.1381 4.75 11 4.75H8C7.58579 4.75 7.25 4.41421 7.25 4C7.25 3.58579 7.58579 3.25 8 3.25H11ZM19 8.75H5C4.30964 8.75 3.75 9.30964 3.75 10V18C3.75 18.6904 4.30964 19.25 5 19.25H19C19.6904 19.25 20.25 18.6904 20.25 18V10C20.25 9.30964 19.6904 8.75 19 8.75ZM18.75 17C18.75 16.5858 18.4142 16.25 18 16.25H6C5.58579 16.25 5.25 16.5858 5.25 17C5.25 17.4142 5.58579 17.75 6 17.75H18C18.4142 17.75 18.75 17.4142 18.75 17ZM8 13.25C8.41421 13.25 8.75 13.5858 8.75 14C8.75 14.4142 8.41421 14.75 8 14.75H6C5.58579 14.75 5.25 14.4142 5.25 14C5.25 13.5858 5.58579 13.25 6 13.25H8ZM13.75 14C13.75 13.5858 13.4142 13.25 13 13.25H11C10.5858 13.25 10.25 13.5858 10.25 14C10.25 14.4142 10.5858 14.75 11 14.75H13C13.4142 14.75 13.75 14.4142 13.75 14ZM18 13.25C18.4142 13.25 18.75 13.5858 18.75 14C18.75 14.4142 18.4142 14.75 18 14.75H16C15.5858 14.75 15.25 14.4142 15.25 14C15.25 13.5858 15.5858 13.25 16 13.25H18ZM8.75 11C8.75 10.5858 8.41421 10.25 8 10.25H6C5.58579 10.25 5.25 10.5858 5.25 11C5.25 11.4142 5.58579 11.75 6 11.75H8C8.41421 11.75 8.75 11.4142 8.75 11ZM13 10.25C13.4142 10.25 13.75 10.5858 13.75 11C13.75 11.4142 13.4142 11.75 13 11.75H11C10.5858 11.75 10.25 11.4142 10.25 11C10.25 10.5858 10.5858 10.25 11 10.25H13ZM18.75 11C18.75 10.5858 18.4142 10.25 18 10.25H16C15.5858 10.25 15.25 10.5858 15.25 11C15.25 11.4142 15.5858 11.75 16 11.75H18C18.4142 11.75 18.75 11.4142 18.75 11Z"
				/>
			</Svg>
		);
	}
);
SvgKeyboard24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgKeyboard24;
